import React, { useContext } from "react";
import { View, StyleSheet, Platform, VirtualizedList, Dimensions } from "react-native";

import {
  RecyclerListView,
  DataProvider,
  LayoutProvider,
} from "recyclerlistview";

import Prediction from "./Prediction";
import {hasItems, isAppleDevice, isWeb} from "../../../../helpers/utils";
import PredictionMore from "./PredictionMore";
import Icons from "../../common/icons";
import appStyles from "../../../appStyles";
import AppConfig from "../../../../config/AppConfig";

const USE_RECYCLER_LIST = false;

const { width: WIDTH, height: HEIGHT } = Dimensions.get("window");

function PredictionsList(props) {
  const {
    timeslot,
    minutesInterval = 15,
    onTimeslotSelected = () => {},
    onActivitySelected = () => {},
    expandTimeslot = () => {},
    hasChunks = false,
    showTrackTutorials = false,
    showIcons = true,
  } = props;

  const showUnchunkIcon = hasChunks && timeslot.duration > minutesInterval;
  const itemsToRender = 11;
  const renderPerBatch = 3;
  const windowSize = 3;
  const predicted_activities = hasItems(timeslot.predicted_activities)
    ? showTrackTutorials
      ? timeslot.predicted_activities.slice(0, 5)
      : [...timeslot.predicted_activities, { showMore: true }]
    : [];

  const keyExtractor = (item) => timeslot.id + "-" + item.id;
  const getItemData = (data, index) => predicted_activities[index];
  const itemCount = () =>
    predicted_activities != null ? predicted_activities.length : 0;

  const renderItem = ({ item, index }) => {
    return item.showMore ? (
      <PredictionMore
        onPress={() => onTimeslotSelected(timeslot)}
        key={index}
      />
    ) : (
      <Prediction
        prediction={item}
        key={index}
        position={index}
        showIcons
        {...props}
      />
    );
  };
  const width = isWeb
      ? Math.min(WIDTH, AppConfig.MAX_WIDTH)
      : isAppleDevice
          ? WIDTH * 2
          : WIDTH;
  const dataProvider = USE_RECYCLER_LIST ? new DataProvider((r1, r2) => {
    return r1 !== r2;
  }).cloneWithRows(predicted_activities) : null;
  const layoutProvider = new LayoutProvider(
      () => 0,
      (type, dim) => {
        dim.width = 115;
        dim.height = 40;
      },
  );
  const rowRenderer = (type, data, index) => {
    return renderItem({ item: data, index });
  };


  return (
    <View style={appStyles.timeslot}>
      {showUnchunkIcon ? (
        <Icons.AddIcon
          onPress={() => expandTimeslot(timeslot)}
          style={[appStyles.iconContainer, styles.editIcon]}
        />
      ) : null}

      {USE_RECYCLER_LIST ?
          <RecyclerListView
              isHorizontal={true}
              useWindowScroll={false}
              rowRenderer={rowRenderer}
              dataProvider={dataProvider}
              layoutProvider={layoutProvider}
              renderAheadOffset={0}
              scrollViewProps={{
                overflow: "hidden",
                showsHorizontalScrollIndicator: false,
                showsVerticalScrollIndicator: false
              }}
              contentContainerStyle={[styles.predictions, { paddingRight: 100 }]}
              style={{
                overflow: "hidden",
                width: width,
                zIndex: -1,
                height: 40,
                top: 3,
                maxWidth: AppConfig.MAX_WIDTH,
              }}
              initialRenderIndex={0}
              keyboardShouldPersistTaps="handled"
          />
      : <VirtualizedList
        horizontal
        showsHorizontalScrollIndicator={false}
        removeClippedSubviews={true}
        style={{
          overflow: "hidden",
          maxWidth: AppConfig.MAX_WIDTH,
        }}
        contentContainerStyle={[styles.predictions, { paddingRight: 100 }]}
        getItemCount={itemCount}
        getItem={getItemData}
        initialNumToRender={itemsToRender}
        maxToRenderPerBatch={renderPerBatch}
        updateCellsBatchingPeriod={250}
        windowSize={windowSize}
        // This data is not needed, but rather is bound to the FlatList internal PureComponent
        // shouldComponentUpdate hook
        extraData={onActivitySelected}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
        getItemLayout={(data, index) => ({
          offset: 100 * index,
          length: 100,
          index,
        })}
      />}
    </View>
  );
}

const styles = StyleSheet.create({
  predictions: Platform.select({
    ios: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      height: "100%",
    },
    android: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      height: "100%",
    },
    web: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      overflowX: "hidden",
      overflowY: "hidden",
      height: "100%",
    },
  }),
  editIcon: {
    marginRight: 0,
  },
});

export default PredictionsList;
